import React, { useState } from "react";
import { GrLinkNext, GrLinkPrevious } from "react-icons/gr";
import { TailSpin } from "react-loader-spinner";

export default function QuestionForm({
  currentQuestion = {
    question: "",
    questionType: "multipleChoice",
    options: ["", "", "", ""],
    correctAnswer: 0,
    timeLimit: 60,
  },
  handleInputQuestion,
  handleOptionChange,
  handleCheckOptionChange,
  handleTimeLimitChange,
  handleQuestionTypeChange,
  addQuestion,
  nextStep,
  prevStep,
  questionNumber,
}) {
  const [questionError, setQuestionError] = useState("");
  const [optionsError, setOptionsError] = useState("");
  const [correctAnswerError, setCorrectAnswerError] = useState("");
  const [timeLimitError, setTimeLimitError] = useState("");
  const [generalError, setGeneralError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const validateForm = () => {
    let hasError = false;

    if (!currentQuestion.question.trim()) {
      setQuestionError("Question is required.");
      hasError = true;
    } else {
      setQuestionError("");
    }

    if (currentQuestion.questionType === "multipleChoice") {
      const emptyOptions = currentQuestion.options.some((option) => !option.trim());
      if (emptyOptions) {
        setOptionsError("All options are required.");
        hasError = true;
      } else {
        setOptionsError("");
      }
    }

    if (currentQuestion.correctAnswer === null || currentQuestion.correctAnswer === undefined) {
      setCorrectAnswerError("Please select the correct answer.");
      hasError = true;
    } else {
      setCorrectAnswerError("");
    }

    if (currentQuestion.timeLimit < 10 || currentQuestion.timeLimit > 200) {
      setTimeLimitError("Time limit must be between 10 and 200 seconds.");
      hasError = true;
    } else {
      setTimeLimitError("");
    }

    return !hasError;
  };

  const handleAddQuestion = async () => {
    if (validateForm()) {
      setGeneralError("");
      setIsLoading(true);
      await addQuestion();
      setIsLoading(false);
    } else {
      setGeneralError("Please fix the errors before adding the question.");
    }
  };

  const handleNext = () => {
    setGeneralError("");
    nextStep();
  };

  return (
    <div className="question-form">
      <h2 className="form-title">Question {questionNumber + 1}</h2>

      <div className="form-group">
        <label>Question Type:</label>
        <select
          className="form-select"
          name="questionType"
          value={currentQuestion.questionType}
          onChange={handleQuestionTypeChange}
          required
        >
          <option value="multipleChoice">Multiple Choice</option>
          <option value="trueFalse">True/False</option>
        </select>
      </div>

      <div className="form-group">
        <label>Question:</label>
        <textarea
          className="form-textarea"
          name="question"
          value={currentQuestion.question}
          onChange={handleInputQuestion}
          placeholder="Enter your question here"
          required
          rows="3"
        />
        {questionError && <div className="error-message">{questionError}</div>}
      </div>

      <div className="options-section">
        <label>Options:</label>
        {currentQuestion.options.map((option, index) => (
          <div key={index} className="option-group">
            <input
              type="text"
              className="form-input"
              value={option}
              onChange={(e) => handleOptionChange(index, e.target.value)}
              placeholder={`Option ${index + 1}`}
            />
            <div className="radio-wrapper">
              <input
                type="radio"
                name="correctAnswer"
                checked={currentQuestion.correctAnswer === index}
                onChange={() => handleCheckOptionChange(index)}
              />
              <label>Correct</label>
            </div>
          </div>
        ))}
        {optionsError && <div className="error-message">{optionsError}</div>}
        {correctAnswerError && <div className="error-message">{correctAnswerError}</div>}
      </div>

      <div className="form-group">
        <label>Time Limit (seconds):</label>
        <input
          type="number"
          className="form-input times"
          name="timeLimit"
          value={currentQuestion.timeLimit}
          onChange={handleTimeLimitChange}
          min="10"
          max="200"
          required
        />
        {timeLimitError && <div className="error-message">{timeLimitError}</div>}
      </div>

      {generalError && <div className="error-message">{generalError}</div>}

      <div className="form-actions">
        <button 
          type="button" 
          className="Btn" 
          onClick={handleAddQuestion}
          disabled={isLoading}
        >
          {isLoading ? (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px' }}>
              <TailSpin
                visible={true}
                height="20"
                width="20"
                color="#fff"
                ariaLabel="tail-spin-loading"
                radius="1"
              />
              <span>Adding Question...</span>
            </div>
          ) : (
            "Add Question"
          )}
        </button>
        <button type="button" className="Btn " onClick={prevStep}>
          <GrLinkPrevious /> Previous
        </button>
        <button type="button" className="Btn " onClick={handleNext}>
          Next Step <GrLinkNext />
        </button>
      </div>
    </div>
  );
}